module.exports = __webpack_public_path__ + "img/md.31ef8121.svg";